<div class="modal modal-xl fade" id="addPropertiesToMemberModal" msEscClose (escPressed)="onCancelRequested()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <h5 class="modal-title">Add Member to Properties</h5>
            </div>
            <div class="modal-body">
                <ms-property-list 
                  [activeMemberId]="member()?.memberId" 
                  [currentPropertyListViewLocation]="propertyListViewLocations.AddPropertyToMemberModal"
                  (addMemberRequested)="onAddMemberRequested($event)"
                ></ms-property-list>
            </div>
            <div class="modal-footer border-0 p-4">
                <button type="button" class="btn btn-ms-secondary" data-bs-dismiss="modal" (click)="onCancelRequested()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<ms-info-modal 
  #addPropertiesToMemberInfoModalRef
  modalId="addPropertiesToMemberInfoModal"
  (onConfirm)="onConfirmInfoModal()"
/>

<ms-confirmation-modal 
  #addPropertiesToMemberConfirmationModalRef
  modalId="addPropertiesToMemberConfirmationModal"
  confirmButtonText="Add"
  cancelButtonText="Cancel"
  [isSubmitting]="isSubmitting"
  (confirmed)="addMemberToProperty()"
  (cancelled)="abortConfirmation()"
/>
